<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800">
      <v-card max-width="800">
        <v-toolbar class="black--text" :color="$store.getters.stdColorLight">
          <v-toolbar-title>{{ $t('message.helpTitle') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p>
            <span style="white-space: pre-line" v-html="getHelpText()"></span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="$store.getters.stdColorDark" text @click="ok()">{{ $t("message.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "optima-help-list",

  data: vm => ({
    dialog: true,
    helpItem: [
      {
        question: vm.$t("message.helpLogon1_Q"),
        answer: vm.$t("message.helpLogon1_A"),
        loggedOn: false
      },
      {
        question: vm.$t("message.helpLogon2_Q"),
        answer: vm.$t("message.helpLogon2_A"),
        loggedOn: false
      },
      {
        question: vm.$t("message.helpLogon3_Q"),
        answer: vm.$t("message.helpLogon3_A"),
        loggedOn: false
      },
      {
        question: vm.$t("message.helpOther1_Q"),
        answer: vm.$t("message.helpOther1_A"),
        loggedOn: true
      },
      {
        question: vm.$t("message.helpOther2_Q"),
        answer: vm.$t("message.helpOther2_A"),
        loggedOn: true
      },
      {
        question: vm.$t("message.helpOther3_Q"),
        answer: vm.$t("message.helpOther3_A"),
        loggedOn: true
      },
      {
        question: vm.$t("message.helpOther4_Q"),
        answer: vm.$t("message.helpOther4_A"),
        loggedOn: true
      },
      {
        question: vm.$t("message.helpOther5_Q"),
        answer: vm.$t("message.helpOther5_A"),
        loggedOn: true
      },
      {
        question: vm.$t("message.helpOther6_Q"),
        answer: vm.$t("message.helpOther6_A"),
        loggedOn: true
      }
    ],
  }),

  methods: {
    ok()
    {
      this.$store.dispatch("setShowHelpList", false);
      this.dialog=false;
    },

    getHelpText()
    {
      var returnValue="";
      this.helpItem.forEach(function (arrayItem) {
        returnValue=returnValue+"<table>";

        if (this.$store.getters.isLoggedOn==arrayItem.loggedOn)
        {
          returnValue=returnValue+"<tr><td>";
          returnValue=returnValue+arrayItem.question;
          returnValue=returnValue+"</td></tr>";

          returnValue=returnValue+"<tr><td>";
          returnValue=returnValue+arrayItem.answer;
          returnValue=returnValue+"</td></tr>";

          returnValue=returnValue+"</table>";
          returnValue=returnValue+"<br>";
        }
      }, this);

      return returnValue;
    }
  }

};
</script>

<style scoped>
</style>
